"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useConnections(query) {
  const { ...rest } = useElements("connections", query);
  return {
    connections: rest.items,
    ...rest
  };
}

export { useConnections };
